// Единый словарь статусов заказа для всей админки.
// Раньше подписи жили в каждой странице своей копией и разъехались: в карточке клиента
// «Готов»/«Выполнен», в календаре «Собран»/«Завершён», у курьеров «Доставлен», в загрузке
// «Упаковка». Эталон — календарь/заказы. Цвета бейджей — CSS-классы badge-<class> в styles.css
// (badge-os-*: свои у статусов заказа, чтобы не задевать бейджи склада и Flowwow).

export const ORDER_STATUS = {
  new: { label: 'Новый', class: 'os-new' },
  packaging: { label: 'На упаковке', class: 'os-packaging' },
  ready: { label: 'Собран', class: 'os-ready' },
  courier: { label: 'У курьера', class: 'os-courier' },
  completed: { label: 'Завершён', class: 'os-completed' },
  cancelled: { label: 'Отменён', class: 'os-cancelled' },
};

// Только фирменная палитра NovaFlo (site/assets/brand/tokens.css): песок, охра, терракота, сосна.
// bg/color — бейдж в списках; accent — рамка и заливка кнопки статуса в карточке заказа.
// Те же значения — в styles.css (.badge-os-*).
export const ORDER_STATUS_COLORS = {
  new: { bg: '#EBEDEC', color: '#5E6561', accent: '#5E6561' },        // sand-100 / sand-700
  packaging: { bg: '#F9EBCF', color: '#7E5D00', accent: '#7E5D00' },  // warning-100 / warning-700
  ready: { bg: '#FFE7DD', color: '#B0603C', accent: '#B0603C' },      // terra-100 / terra-600
  courier: { bg: '#1C3D2E', color: '#F4F4EF', accent: '#1C3D2E' },    // pine-900, заливка
  completed: { bg: '#DFF2E8', color: '#1C3D2E', accent: '#4A8C6E' },  // pine-100 / pine-900, кнопка pine-600
  cancelled: { bg: '#FFE6E3', color: '#CB4D45', accent: '#CB4D45' },  // danger-100 / danger-600
};

/** Подпись статуса; неизвестный статус — как есть */
export function orderStatusLabel(status) {
  return ORDER_STATUS[status]?.label || status || '';
}

/** Плоская карта status → подпись (для страниц, где нужна просто строка) */
export const ORDER_STATUS_LABELS = Object.fromEntries(
  Object.entries(ORDER_STATUS).map(([k, v]) => [k, v.label]),
);
